import * as actionTypes from "../actions/handelAuth";

const initialState = {
  token: null,
  userId: null,
  error: false,
  loading: false,
  email: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        //action
        token: action.token,
        userId: action.userId,
        email: action.email,
        //
        loading: false,
        error: false,
      };
    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actionTypes.LOGOUT:
      return {
        ...state,
        token: null,
      };

    default:
      return state;
  }
};

export default reducer;
